import React from 'react';
import ModuleGroupHeader from '../ModuleGroupHeader';
import ModuleGroupContent from '../ModuleGroupContent';

const ModuleGroupServer = () => {
    return (
        <>
            <ModuleGroupHeader />
            <ModuleGroupContent />
        </>
    );
};

export default ModuleGroupServer;
